import { z } from 'zod'

export const encodedClaimsSchema = z.object({
  claims: z.string()
})

export type EncodedClaims = z.infer<typeof encodedClaimsSchema>

/**
 * Defines the expected values of claims types, which may not necessarily map
 * 1-to-1 with RoleType
 */
export enum ClaimsType {
  Owner = 'OWNER',
  Manager = 'MANAGER',
  Member = 'MEMBER',
  Observer = 'OBSERVER',
  Supporter = 'SUPPORTER',
  Dealer = 'DEALER'
}

/**
 * Zod schema for claims type
 */
export const claimsTypeSchema = z.enum(ClaimsType)
export const claimsTypeValues = Object.values(ClaimsType)

/**
 * Checks if the string is a valid claims type
 *
 * @param s
 */
export const isClaimsType = (s: string | null): s is ClaimsType =>
  claimsTypeValues.includes(s as ClaimsType)
